import {
  LCObject,
  PagedResultBase,
} from "src/app/services/ui-helpers/_models/interfaces/common.interfaces";

export interface InvitationRequest {
  agreementId: string;
  inviteeCarSellerId?: string;
  inviteeEmail?: string;
  inviteeMobilePhoneContact?: string;
  inviteeName?: string;
  inviteeTelephoneContact?: string;
  inviterCarSellerId?: string;
  inviterEmail?: string;
  inviterName?: string;
}

// Factorizar con back

export interface DPMUserInvitationRequest {
  inviteeParticipantId?: string;
  subject?: string;
  message?: string;
  inviteeClientId?: string;
  inviterEmail?: string;
  inviterName?: string;
  inviterTenantId?: string;
}

export interface CarSellerOnboardingRequest {
  client_name?: string;
  uri_logo?: string;
  description?: string;
  tax_id?: string;
  countryId?: string;
  loginEmail?: string;
  loginPassword?: string;
}

export interface DPMUserOnboardingRequest {
  clientName?: string;
  clientFamilyname1?: string;
  clientFamilyname2?: string;
  countryId?: string;
  loginEmail?: string;
  loginPassword?: string;
}

export enum BusinessProcessTokenTypeEnum {
  inventoryAgreementInvitation = "inventoryAgreementInvitation",
}

export enum TokenStateEnum {
  live = "live",
  used = "used",
  expired = "expired",
}

export interface BusinessProcessToken extends LCObject {
  tokenFaceId: string;
  type: BusinessProcessTokenTypeEnum;
  status: TokenStateEnum;
  workflowId: string;
  creation?: Date;
  lastUpdate?: Date;
  expiry?: Date;
  rguId?: number;
}

export interface InventoryAgreementInvitationToken
  extends BusinessProcessToken {
  invitationPin?: string;
  invitationPinExpires?: Date;
  invitationStatus: string;
  agreementId: string;
  langId?: string;
  inviterCarSellerId: string;
  inviterName: string;
  inviterSubject?: string;
  inviterMessage?: string;
  inviterEmail: string;
  inviterTelephoneContact?: string;
  inviteeCarSellerId?: string;
  inviteeName: string;
  inviteeEmail: string;
  inviteeTelephoneContact?: string;
  inviteeMobilePhoneContact?: string;
  inviteeTaxId?: string;
  inviteeURILogo?: string;
  loginForInvitee: boolean;
  loginForCarSeller: boolean;
  loginTPAdmin: boolean;
  templateId?: string;
  agreementDes?: string;
  inviterCarSellerDes?: string;
  inviteeCarSellerDes?: string;
}

export interface DPMUserInvitationToken extends BusinessProcessToken {
  invitationPin?: string;
  invitationPinExpires?: Date;
  invitationStatus: string;
  langId?: string;
  inviterName: string;
  inviterSubject?: string;
  inviterMessage?: string;
  inviterEmail: string;
  inviterTelephoneContact?: string;
  inviteeName: string;
  inviteeFamilyName1: string;
  inviteeFamilyName2: string;
  inviteeEmail: string;
  inviteeTelephoneContact?: string;
  inviteeMobilePhoneContact?: string;
  templateId?: string;
  description?: string;
  rguDes?: string;
  inviterDescription?: string;
  inviteeDescription?: string;
  inviteeRegisteredUserId?: number;
  inviteePersonId?: string;
  referenceClientId?: string;
}

export interface InviteeTokenUI {
  faceId: string;
  companyName: string;
  status: TokenStateEnum;
  expiration?: Date;
  loginInvitee: boolean;
  loginCompany: boolean;
  loginTPAdmin: boolean;
}

export enum SeverityLevel {
  error = "error",
  warning = "warning",
  info = "info",
}

export enum InvAgrInvitationTokenSortingEnum {
  DEFAULT = "DEFAULT",
  CREATION_DATE_ASC = "CREATION_DATE_ASC",
  CREATION_DATE_DESC = "CREATION_DATE_DESC",
  EXPIRY_DATE_ASC = "EXPIRY_DATE_ASC",
  EXPIRY_DATE_DESC = "EXPIRY_DATE_DESC",
  INVITER_NAME_ASC = "INVITER_NAME_ASC",
  INVITER_NAME_DESC = "INVITER_NAME_DESC",
  INVITEE_NAME_ASC = "INVITEE_NAME_ASC",
  INVITEE_NAME_DESC = "INVITEE_NAME_DESC",
  INVITER_EMAIL_ASC = "INVITER_EMAIL_ASC",
  INVITER_EMAIL_DESC = "INVITER_EMAIL_DESC",
  INVITEE_EMAIL_ASC = "INVITEE_EMAIL_ASC",
  INVITEE_EMAIL_DESC = "INVITEE_EMAIL_DESC",
  INVITER_SELLER_ASC = "INVITER_SELLER_ASC",
  INVITER_SELLER_DESC = "INVITER_SELLER_DESC",
  INVITEE_SELLER_ASC = "INVITEE_SELLER_ASC",
  INVITEE_SELLER_DESC = "INVITEE_SELLER_DESC",
  STATUS_ASC = "STATUS_ASC",
  STATUS_DESC = "STATUS_DESC",
}

export interface BusinessProcessTokenFilter {
  tokenFaceId?: string;
  status?: TokenStateEnum;
  workflowId?: string;
  creationFrom?: Date;
  creationTo?: Date;
  lastUpdateFrom?: Date;
  lastUpdateTo?: Date;
  expiryFrom?: Date;
  expiryTo?: Date;
  freeText?: string;
}

export enum InvAgrStateEnum {
  TOKEN_CREATED = "TOKEN_CREATED",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
  JOINING_AGREEMENT_FAILED = "JOINING_AGREEMENT_FAILED",
  INVITATION_SENT = "INVITATION_SENT",
  INVITATION_ACCEPTED = "INVITATION_ACCEPTED",
  INVITATION_REJECTED = "INVITATION_REJECTED",
  COMPANY_CREATED = "COMPANY_CREATED",
  AGREEMENT_JOINED = "AGREEMENT_JOINED",
}

export interface InvAgrInvitationTokenFilter
  extends BusinessProcessTokenFilter {
  invitationPin?: string;
  invitationStatus?: InvAgrStateEnum;
  agreementId?: string;
  inviterCarSellerId?: string;
  inviterName?: string;
  inviterEmail?: string;
  inviterTelephoneContact?: string;
  inviteeCarSellerId?: string;
  inviteeName?: string;
  inviteeEmail?: string;
  inviteeTelephoneContact?: string;
  inviteeMobilePhoneContact?: string;
  sortBy?: InvAgrInvitationTokenSortingEnum;
}

export interface PagedResultInvitationTokens extends PagedResultBase {
  data?: InventoryAgreementInvitationToken[];
}
